import { jsx as _jsx } from "react/jsx-runtime";
import { TextField, IconButton, Icon } from '@emburse/embark-core';
import { useState } from 'react';
import { $t, useTranslation } from '../../hooks/useTranslation';
export default function InputPassword({ id, value, defaultValue, label, placeholder, disabled, helperText, error, onChangeHandler }) {
    useTranslation();
    const [showPassword, setShowPassword] = useState(false);
    const showPasswordHandler = () => {
        setShowPassword(!showPassword);
    };
    return (_jsx(TextField, { id: id, name: id, fullWidth: true, value: value, defaultValue: defaultValue, label: label, type: showPassword ? 'text' : 'password', placeholder: placeholder, disabled: disabled || null, helperText: helperText, error: error, onChange: onChangeHandler, endAdornment: _jsx(IconButton, { size: "medium", title: showPassword ? $t('Hide password') : $t('Show Password'), onClick: showPasswordHandler, children: _jsx(Icon, { isLigature: true, fontIcon: showPassword ? 'visibility_off' : 'visibility' }) }) }));
}
InputPassword.defaultProps = {
    onChangeHandler: () => { }
};
